"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _today = _interopRequireDefault(require("./components/today.vue"));
var _temperature = _interopRequireDefault(require("./components/temperature.vue"));
var _theme = _interopRequireDefault(require("./components/theme.vue"));
var _chart = _interopRequireDefault(require("./components/chart.vue"));
var _systemParams = _interopRequireDefault(require("./components/systemParams.vue"));
var _facilityParams = _interopRequireDefault(require("./components/facilityParams.vue"));
var _pie = _interopRequireDefault(require("./components/pie.vue"));
var _alarm = _interopRequireDefault(require("./components/alarm.vue"));
var _tabs = _interopRequireDefault(require("./components/tabs.vue"));
var _bigBorder = _interopRequireDefault(require("./components/bigBorder.vue"));
var _home = require("@/api/home");
var _default = exports.default = {
  components: {
    today: _today.default,
    temperature: _temperature.default,
    theme: _theme.default,
    chart: _chart.default,
    system: _systemParams.default,
    facility: _facilityParams.default,
    pie: _pie.default,
    alarm: _alarm.default,
    tabs: _tabs.default,
    bigBorder: _bigBorder.default
  },
  data: function data() {
    return {
      wsIp: process.env.VUE_APP_BASE_API,
      homeData: [],
      notification: {},
      title: this.$store.state.project.projectInfo.entryName,
      imgUrl: this.$store.state.project.projectInfo.projectScreenPicture
    };
  },
  //方法集合
  methods: {
    getProjectListData: function getProjectListData() {
      var _this = this;
      (0, _home.getProjectList)({
        projectId: this.$store.state.project.projectInfo.id,
        type: this.isCold || 1
      }).then(function (res) {
        _this.homeData = res;
      });
    },
    initWebSocket: function initWebSocket() {
      var _this2 = this;
      if (this.ws) {
        this.ws.close();
      }
      if ("WebSocket" in window) {
        var i = this.wsIp.indexOf("//");
        var url = this.wsIp.slice(i);
        this.ws = new WebSocket("".concat(process.env.VUE_APP_WSS_STATUS == "true" ? "wss" : "ws", ":").concat(url, "/websocketServer/energyHomePageData/").concat(this.$store.state.project.projectInfo.id, "/").concat(this.isCold));
        this.ws.onopen = function () {};
        this.ws.onmessage = function (message) {
          _this2.homeData = JSON.parse(message.data);
        };
      }
    }
  },
  computed: {
    isCold: function isCold() {
      return this.$store.state.project.isCold;
    },
    computedImageUrl: function computedImageUrl() {
      return this.imgUrl || require('@/assets/screenbj.jpg');
    }
  },
  watch: {
    isCold: function isCold(val) {
      this.getProjectListData();
      this.initWebSocket();
    }
  },
  created: function created() {
    this.getProjectListData();
    this.$store.dispatch("project/setProjectCold", 1);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch("project/setProjectCold", null);
    if (this.ws) {
      this.ws.close();
    }
    ;
  }
};